import React, { memo } from 'react';

import proptypes from 'prop-types';
import './PromoWarningMessage.scss';

const { string } = proptypes;

export const PromoWarningMessage = memo(({ message }) => (
  <div className="promo-warning-message">
    <span>{message}</span>
  </div>
));

PromoWarningMessage.displayName = 'PromoWarningMessage';

PromoWarningMessage.propTypes = {
  message: string.isRequired
};
